document.addEventListener("DOMContentLoaded", function () {
  // Select the size guide link
  var socialLink = document.getElementById("social-link");

  // Select the social overlay
  var socialMediaOverlay = document.getElementById("social-media-overlay");

  // Select the close button in the social overlay
  // var socialClose = document.getElementById("social-close");

  // Add click event listener to open the social overlay
  if (socialLink && socialMediaOverlay) {
    socialLink.addEventListener("click", function (event) {
      event.preventDefault(); // Prevent the default behavior of the link
      showSizeOverlay();
    });
  }

  // Add click event listener to close the social overlay
  if (socialMediaOverlay) {
    socialMediaOverlay.addEventListener("click", function () {
      hideSizeOverlay();
    });
  }

  // Function to display the social overlay
  function showSizeOverlay() {
    // Check if the social overlay exists
    if (socialMediaOverlay) {
      socialMediaOverlay.style.opacity = 1;
      socialMediaOverlay.style.visibility = "visible";

      document.body.style.overflow = "hidden";
    }
  }

  // Function to hide the social overlay
  function hideSizeOverlay() {
    // Check if the social overlay exists
    if (socialMediaOverlay) {
      socialMediaOverlay.style.opacity = 0;
      socialMediaOverlay.style.visibility = "hidden";

      document.body.style.overflow = "auto";
    }
  }
});
